import FOOTER from './Footer.json';
import MENU from './Menu.json';
export default {
  FOOTER,
  MENU,
};
